const successStatus = [
    {code: 'DGC', title: 'Doručené osobne',},
    {code: 'WPD', title: 'Doručené neosobne',},
    {code: 'ROD', title: 'Doručené s výhradou',},
    {code: 'DWD', title: 'Doručené poškodené',},
    {code: 'DBS', title: 'Vrátené odosielatelovi',},
];
export default successStatus;
